import React, { useState } from "react";
import { auth, db } from "../services/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { ref, get } from "firebase/database";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css"; // updated CSS file

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleAdminLogin = async () => {
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      const user = result.user;

      // Check if user is in admin list
      const adminRef = ref(db, `admins/${user.uid}`);
      const snapshot = await get(adminRef);

      if (!snapshot.exists()) {
        setError("⛔ Not an admin account.");
        return;
      }

      localStorage.setItem("user", JSON.stringify(user));
      alert("Admin Login Successful");
      navigate("/dashboard");
    } catch (err) {
      setError("Login failed: " + err.message);
    }
  };

  return (
    <div className="adl-container">
      <h2 className="adl-title">Admin Login</h2>

      <input
        className="adl-input"
        type="email"
        placeholder="Admin Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        className="adl-input"
        type="password"
        placeholder="Admin Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <button className="adl-btn" onClick={handleAdminLogin}>
        Login as Admin
      </button>

      {error && <p className="adl-error">{error}</p>}

      <p className="adl-link">
        <a href="/login">Back to User Login</a>
      </p>
    </div>
  );
}

export default AdminLogin;
/* ================================ */